import { primitives, tokens } from "@adasupport/byron";
import { type TransitionStatus } from "react-transition-group/Transition";
import styled, { css } from "styled-components";

import { cssVariables } from "constants/css";

import { type FlyoutPanelWidths } from ".";

export const FlyoutPanel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 675px;
  z-index: 9999;
`;

export const FlyoutWindow = styled.div<{
  state: TransitionStatus;
  width: FlyoutPanelWidths;
}>`
  position: fixed;
  display: flex;
  flex-direction: column;
  z-index: 2;
  background: ${tokens.colors.background.main};
  width: ${(p) => `${p.width}px`};
  height: 100%;
  right: 0; /* ensure the window flies out from the right */
  opacity: 1;
  transition: transform 300ms ease-in-out, opacity 300ms ease-in-out;
  /* initial state, off the edge of the right side of the screen */
  transform: translateX(100%);
  box-shadow: ${cssVariables.boxShadow};

  ${(p) =>
    p.state === "entering" || p.state === "entered"
      ? css`
          transform: translateX(0);
          opacity: 1;
        `
      : null}
`;

export const FlyoutContent = styled.div`
  overflow-y: scroll;
  flex: 1 1 0;
`;

export const CloseButton = styled.div`
  position: absolute;
  top: ${primitives.spacing.space2};
  right: ${primitives.spacing.space2};
  z-index: ${cssVariables.zIndexFlyoutButton};
`;
